// ---------------------------------------------------------------------------
// RH · Recrutamento & Seleção — leitura de erro da API (padrão do submódulo
// Vendas). Espelha o contrato JSend de erro (fail/error) de forma defensiva
// (errors ausente / string / objeto). Some quando a infra global FC1/FC4
// (ApiError/notifyApiError) for ligada; por ora é local ao módulo.
//
// Política (FC4): 422 com `field` → inline via `fieldErrors`; o resto → toast.
// O dicionário por `code` dá mensagem específica pros guards do handoff 0061 §3.
// ---------------------------------------------------------------------------

// Dicionário code → mensagem pt-BR (cresce sob demanda; não duplicar por tela).
export const RECRUITMENT_ERROR_MESSAGES = {
   candidate_already_in_process:
      'Este candidato já está em um processo seletivo.',
   candidate_wrong_stage:
      'O candidato não está na etapa necessária para esta ação.',
   invalid_result_for_round:
      'Resultado inválido para esta rodada de entrevista.',
   job_opening_not_open: 'A vaga selecionada não está aberta.',
   interview_already_active: 'Já existe uma entrevista ativa desta rodada.',
   interview_already_concluded:
      'Esta entrevista já teve o resultado registrado.',
   interview_not_active: 'Esta entrevista não está mais ativa.',
   missing_file: 'Selecione um arquivo para enviar.',
   candidate_not_found: 'Candidato não encontrado.',
   job_opening_not_found: 'Vaga não encontrada.',
   interview_not_found: 'Entrevista não encontrada.',
   resume_not_found: 'Currículo não encontrado.',
   // ─── Fase 1 — onboarding / admissão (handoff 0065) ───────────────────────
   invalid_onboarding_transition:
      'O onboarding avança um passo por vez. A tela foi atualizada — tente novamente.',
   // ─── F2 — background check (handoff 0067) ────────────────────────────────
   background_check_not_approved:
      'Conclua as duas análises do background check (aprovadas) antes de avançar.',
   onboarding_already_finalized:
      'Este onboarding já foi finalizado e não pode mais ser editado.',
   exam_document_not_found: 'Laudo do exame não encontrado.',
   onboarding_not_ready_for_admission:
      "O onboarding precisa estar em 'Aguardando início' para admitir.",
   missing_fields:
      'Complete o pré-cadastro (empresa, cargo, departamento, centro de custo e salário) antes de admitir.',
   missing_start_date:
      'Defina a data de início no pré-cadastro antes de admitir.',
   onboarding_not_found: 'Onboarding não encontrado.',
   dependent_not_found: 'Dependente não encontrado.',
   document_not_found: 'Documento não encontrado.',
};

// Normaliza o erro do axios em { status, code, message, fieldErrors, errors }.
export function readApiError(err) {
   const data = err?.response?.data;
   const status = err?.response?.status ?? 0;
   const errors = Array.isArray(data?.errors) ? data.errors : [];
   const first = errors[0] ?? null;

   const fieldErrors = {};
   errors.forEach((entry) => {
      if (entry?.field) fieldErrors[entry.field] = entry.message;
   });

   return {
      status,
      code: first?.code ?? data?.code ?? null,
      message: first?.message ?? data?.message ?? err?.message ?? null,
      fieldErrors,
      errors,
   };
}

// Mensagem apresentável para toast: dicionário por code → mensagem do backend →
// fallback. Use nos erros que NÃO são de campo (validação 422 com field vai
// inline via readApiError().fieldErrors).
export function recruitmentErrorMessage(
   err,
   fallback = 'Ocorreu um erro. Tente novamente.',
) {
   const { code, message } = readApiError(err);
   return RECRUITMENT_ERROR_MESSAGES[code] ?? message ?? fallback;
}
